import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Server, ChevronRight, Search, Plus } from 'lucide-react';
import { getSchools } from '../api';

export default function Schools() {
  const [schools, setSchools] = useState([]);
  const [search, setSearch] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    getSchools().then(r => setSchools(r.data.results || r.data));
  }, []);

  const filtered = schools.filter(s =>
    s.name.toLowerCase().includes(search.toLowerCase()) ||
    s.school_id.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div>
      <div className="page-header">
        <h2>Schools</h2>
        <p>Manage all deployed school instances</p>
      </div>

      <div className="card">
        <div className="card-header">
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, flex: 1, marginRight: 16 }}>
            <Search size={16} className="text-muted" />
            <input
              type="text"
              className="form-input"
              placeholder="Search schools..."
              value={search}
              onChange={e => setSearch(e.target.value)}
              style={{ border: 'none', padding: '8px 0', boxShadow: 'none', flex: 1 }}
            />
          </div>
          <button className="btn btn-primary btn-sm" onClick={() => navigate('/deploy')}>
            <Plus size={15} /> Deploy
          </button>
        </div>
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>School</th>
                <th>Domain</th>
                <th>Ports</th>
                <th>Plan</th>
                <th>Status</th>
                <th>Monthly</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {filtered.map(s => (
                <tr key={s.school_id} className="clickable" onClick={() => navigate(`/schools/${s.school_id}`)}>
                  <td>
                    <strong>{s.name}</strong>
                    <br />
                    <span className="text-muted text-xs">{s.school_id}</span>
                  </td>
                  <td className="font-mono text-sm">{s.domain}</td>
                  <td className="font-mono text-sm">{s.frontend_port}/{s.backend_port}</td>
                  <td className="text-sm" style={{ textTransform: 'capitalize' }}>{s.plan}</td>
                  <td><span className={`badge ${s.status}`}>{s.status}</span></td>
                  <td className="font-mono">${s.monthly_price}</td>
                  <td><ChevronRight size={16} className="text-muted" /></td>
                </tr>
              ))}
              {filtered.length === 0 && (
                <tr>
                  <td colSpan={7}>
                    <div className="empty-state">
                      <Server size={40} />
                      <p>{search ? 'No matching schools' : 'No schools yet'}</p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
